import './assets/shared-button.css';const t = "tkFrxq_baseButton", r = "tkFrxq_destructive", s = "tkFrxq_ghost", o = "tkFrxq_primary", e = "tkFrxq_secondary", n = {
  baseButton: t,
  destructive: r,
  ghost: s,
  "night-aware": "tkFrxq_night-aware",
  primary: o,
  secondary: e
};
export {
  n as b
};
//# sourceMappingURL=shared-button.module-BT8NBm4o.js.map
